import React from 'react'
import { useSiteContext, useTranslations, useUserSettings } from '@dustin-web/microsite-components/src/hooks'
import Alert from './components/alert'
import { useAuth } from '@dustin-web/microsite-components/src/auth'

type LoginLinkProps = {
  titleTranslationKey: string | null
  bodyTranslationKey: string
  url?: string
  email: string
  returnUrl: string | null
}

const LoginLink = ({ titleTranslationKey, bodyTranslationKey, email, returnUrl }: LoginLinkProps) => {
  const { translate } = useTranslations()
  const { signIn } = useAuth()
  const { twoLetterISOLanguageName } = useUserSettings()
  const { siteType } = useSiteContext()

  const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    signIn({
      cancellationUrl: window.location.origin,
      provider: 'okta',
      siteType: siteType === 'Business' ? 'business' : 'consumer',
      username: email,
      returnUrl: returnUrl ?? window.location.origin,
      language: twoLetterISOLanguageName,
    })
  }

  return (
    <Alert variant="danger">
      {titleTranslationKey && <p>
        <strong>{translate(titleTranslationKey)}</strong>
      </p>}

      <a onClick={handleOnClick} style={{ cursor: 'pointer' }}>{translate(bodyTranslationKey)}</a>
    </Alert>
  )
}

export default LoginLink
